import(/* webpackMode: "eager" */ "/app/node_modules/@fortawesome/fontawesome-svg-core/styles.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@ncdai/react-wheel-picker/dist/index.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/local/target.css?{\"path\":\"src/app/[locale]/layout.js\",\"import\":\"\",\"arguments\":[{\"src\":[{\"path\":\"../../../public/fonts/turna/TT_Hoves_Pro_IRegular.woff2\",\"weight\":\"400\",\"style\":\"normal\"},{\"path\":\"../../../public/fonts/turna/TT_Hoves_Pro_Medium.woff2\",\"weight\":\"500\",\"style\":\"normal\"},{\"path\":\"../../../public/fonts/turna/TT_Hoves_Pro_DemiBold.woff2\",\"weight\":\"600\",\"style\":\"normal\"}],\"variable\":\"--font-turna\",\"display\":\"swap\",\"adjustFontFallback\":\"Arial\",\"preload\":true}],\"variableName\":\"turnaFont\"}");
;
import(/* webpackMode: "eager", webpackExports: ["AnalyticsProvider"] */ "/app/src/analytics/context/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/IntlErrorHandlingProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/LayoutWrapper.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/PageTransitionProgressBar.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/VivolloChat.js");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/app/src/contexts/AuthContext.js");
;
import(/* webpackMode: "eager", webpackExports: ["CurrencyProvider"] */ "/app/src/contexts/CurrencyContext.js");
;
import(/* webpackMode: "eager", webpackExports: ["LoadingProvider"] */ "/app/src/contexts/LoadingContext.js");
;
import(/* webpackMode: "eager", webpackExports: ["ModalProvider"] */ "/app/src/contexts/ModalContext.js");
;
import(/* webpackMode: "eager", webpackExports: ["TranslationDetectorProvider"] */ "/app/src/contexts/TranslationDetectorProvider.js");
